import Typography from '@mui/material/Typography'
import TableWithLoadingWrapper from '../../../../../components/generic/dataGrid'
import ReportRunActions from '../../../../../components/specific/reports-custom/ReportRunActions'
import ReportRunRowDropdown from '../../../../../components/specific/reports-custom/ReportRunRowDropdown'

const ReportRuns = ({ runDates, loading, removeRuns, reportId, reportName }) => {
  const columns = [
    {
      field: 'date',
      headerName: 'Run Date',
      flex: 1,
      renderCell: (params) => {
        const { run_date } = params.row
        return <Typography variant='primary'>{run_date}</Typography>
      },
    },
    {
      field: 'actions',
      headerName: '',
      flex: 2,
      renderCell: (params) => {
        const row = params.row
        return <ReportRunActions reportId={reportId} runInfo={row} reportName={reportName} />
      },
    },
    {
      field: 'dropdown',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => {
        const row = params.row
        return <ReportRunRowDropdown reportRunInfo={row} removeRuns={removeRuns} reportId={reportId} />
      },
    },
  ]

  return (
    <TableWithLoadingWrapper
      loading={loading}
      pagination={{
        paginationModel: {
          pageSize: 25,
          page: 0,
        },
      }}
      pageSizeOptions={[5, 10, 25]}
      columns={columns}
      dataSource={runDates}
      sortModel={[
        {
          field: 'date',
          sort: 'desc',
        },
      ]}
    />
  )
}

export default ReportRuns
